const TooltipCursor = ({
  text,
  coords,
}: {
  text: string
  coords: { x: number; y: number }
}) => {
  if (!text) return null

  return (
    <div
      className="pointer-events-none fixed z-50 whitespace-pre-wrap rounded-md bg-black px-2 py-1 text-sm text-white shadow-lg transition-opacity duration-150"
      style={{
        left: coords.x + 12,
        top: coords.y + 12,
      }}
    >
      {text}
    </div>
  )
}

export default TooltipCursor
